// src/services/detection/config.js
export const DETECTION_MODELS = {
  MOVENET_THUNDER: 'movenet_thunder',
  MOVENET_LIGHTNING: 'movenet_lightning',
  BLAZEPOSE: 'blazepose',
  COCO_SSD: 'coco_ssd',
  CUSTOM: 'custom'
};

export const DETECTION_CONFIG = {
  defaultModel: DETECTION_MODELS.COCO_SSD,
  
  // Confidence thresholds
  minPoseScore: 0.25,
  minKeypointScore: 0.3,
  minObjectScore: 0.5,
  
  // For lower-leg only view, we'll use object detection
  // and look for shoe-like objects in the frame
  lowerLegMode: {
    enabled: true,
    // Expected foot regions (as ratios of frame)
    expectedRegions: {
      left: { xMin: 0.5, xMax: 1.0, yMin: 0.3, yMax: 1.0 },
      right: { xMin: 0.0, xMax: 0.5, yMin: 0.3, yMax: 1.0 }
    },
    // Bounding box size ratios for pointe shoes
    boundingBox: {
      widthRatio: 0.25,   // Larger ratio since feet are main subject
      heightRatio: 0.35,
      yOffset: 0.1
    }
  },
  
  // Full body mode settings (original)
  fullBodyMode: {
    boundingBox: {
      widthRatio: 0.08,
      heightRatio: 0.15,
      yOffset: 0.2
    }
  },
  
  // Colors for visualization
  colors: {
    left: '#00FF00',
    right: '#FF6600',
    default: '#2196F3',
    uncertain: '#FFFF00'
  },
  
  enableSmoothing: true,
  smoothingWindow: 3
};